import { render } from "./RadarItem.vue?vue&type=template&id=4404bf4c&scoped=true"
import script from "./RadarItem.vue?vue&type=script&lang=js"
export * from "./RadarItem.vue?vue&type=script&lang=js"

import "./RadarItem.vue?vue&type=style&index=0&id=4404bf4c&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4404bf4c"]])

export default __exports__